import {PermissionEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Box, Modal, ModalProps} from "@mantine/core";
import {MouseEvent, useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {usePermissionAction} from "../../menu/PermissionActionMenu/usePermissionAction";
import {EntityActionGroup} from "../../group/EntityActionGroup/EntityActionGroup";
import {BasePermissionDataTable, BasePermissionDataTableProps} from "./BasePermissionDataTable";

export type PermissionDataTableProps = Omit<BasePermissionDataTableProps, 'renderActions'>

export const PermissionDataTable = (props: PermissionDataTableProps) => {
  const {
    ...rest
  } = props

  const navigate = useNavigate()

  const {
    onPermissionActionClick
  } = usePermissionAction()

  const onViewActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: PermissionEntity) => {
    e.stopPropagation()
    navigate(`/permissions/profile?id=${record.id}`)
  }, [navigate])

  const onEditActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: PermissionEntity) => {
    e.stopPropagation()
    // onPermissionActionClick(record, 'EDIT')
  }, [onPermissionActionClick])

  const onDeleteActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: PermissionEntity) => {
    e.stopPropagation()
    // onPermissionActionClick(record, 'DELETE')
  }, [onPermissionActionClick])

  const renderActions = useCallback((record: PermissionEntity, index: number) => {
    return (
      <EntityActionGroup
        permissionPrefix={"permission"}
        edit={false}
        delete={false}
        onViewActionClick={(e) => onViewActionClick(e, record)}
        onEditActionClick={(e) => onEditActionClick(e, record)}
        onDeleteActionClick={(e) => onDeleteActionClick(e, record)}
      />
    )
  }, [onEditActionClick, onViewActionClick, onDeleteActionClick])

  return (
    <BasePermissionDataTable
      {...rest}
      renderActions={renderActions}
    />
  )
}

export type PermissionDataTableModalProps = Omit<ModalProps, "onSubmit"> & {
  dataTable: Omit<PermissionDataTableProps, 'recordsPerPageOptions'>
}

export const PermissionDataTableModal = (props: PermissionDataTableModalProps) => {
  const {t} = useTranslation(["common"]);

  const {
    title = t<string>("common.entity.permission.plural", "Permissions"),
    dataTable,
    ...rest
  } = props;

  return (
    <Modal {...rest} title={title}>
      <Box>
        <PermissionDataTable
          {...dataTable}
          recordsPerPageOptions={[5]}/>
      </Box>
    </Modal>
  );
};
